export default __webpack_public_path__ + "fffd6a697a64594c461e309004acd806.png";